/** Height for 10 rows in a middle-size Ant Design table (10 × 54px) */
export const POSITIONS_TABLE_SCROLL_HEIGHT = 540;
